
export type iGrid = iCell[][];

export enum iCell { null, X, O };

export enum Player {
  Player1 = iCell.X,
  Player2 = iCell.O,
};

export enum GameState {
  Playing,
  Draw,
  Won,
};
